import { useQuery } from '@tanstack/react-query';

import { getBillDetails } from '../api';
import { BILLS_QUERY_KEY } from './use-bills';

const BILL_DETAILS_STALE_TIME = 5 * 60 * 1000;

export const getBillDetailsQueryKey = (billId: number) =>
  [BILLS_QUERY_KEY, 'details', billId] as const;

/** Fetches a bill only when its route parameter is a valid positive integer. */
export const useBillDetails = (billId: number | undefined) =>
  useQuery({
    queryKey: getBillDetailsQueryKey(billId ?? 0),
    queryFn: () => getBillDetails(billId as number),
    enabled: typeof billId === 'number' && Number.isInteger(billId) && billId > 0,
    staleTime: BILL_DETAILS_STALE_TIME,
  });
